// Module
var code = "<template>\n    <require from=\"./../net/net-list\"></require>    \n    <net-list if.bind=\"params.Id\" context=\"special-product-list-customer-list\" params.bind=\"params\" context=\"customer-view\" customerid.bind=\"params.Id\"></net-list>\n</template> ";
// Exports
export default code;